import {
  Box,
  Button,
  Checkbox,
  Divider,
  Group,
  LoadingOverlay,
  Popover,
  Radio,
  Stack,
  Text,
  TextInput,
  Textarea,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconCheck, IconX } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { isNullOrUndefined } from "../../_base/extension/StringExtension";
import Repository from "../../_base/helper/HttpHelper";
import { API_ROUTE } from "../../const/apiRoute";
import { MessageResponse } from "../../model/MessageResponse";
import { TblAttributeCommand } from "../../model/TblAttributeCommand";
import { TblAttributeValueCommand } from "../../model/TblAttributeValueCommand";
import AttributeFormStore from "../../store/AttributeFormStore";
import FormValueAdd from "./formValueAdd";
import ButtonClose from "../../common/ButtonClose/ButtonClose";

const EditViewNew = function ({
  id,
  onSaveFinal,
  store,
}: {
  id: number;
  onSaveFinal?: () => void;
  store: AttributeFormStore;
}) {
  const entity: TblAttributeCommand = {
    id: 0,
    attributeCode: null,
    attributeName: null,
    apikey: null,
    filterCode: null,
    description: null,
    orderNumber: 0,
    status: null,
    creationDate: null,
    createdBy: null,
    lastUpdateDate: null,
    lastUpdatedBy: null,
    lastUpdatedLogin: null,
    attributeGroup: null,
    filterProdStatus: false,
    titleGroupStatus: false,
    shortDescStatus: false,
    displayInTechStatus: false,
    configProdStatus: false,
    listTblAttributeValueCommand: null,
    listTblCategoryAttributeModels: null,
  };

  const entityValue: TblAttributeValueCommand = {
    id: 0,
    attributeId: null,
    value: null,
    description: null,
    orderNumber: null,
    status: null,
    imageUrl: null,
    creationDate: null,
    createdBy: null,
    lastUpdateDate: null,
    lastUpdatedBy: null,
    lastUpdatedLogin: null,
  };

  const form = useForm<TblAttributeCommand>({
    initialValues: { ...entity },
  });
  const [vTblAttributeValueCommand, setTblAttributeValueCommand] = useState<
    TblAttributeValueCommand[]
  >([]);
  const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
  const [visible, { close, open }] = useDisclosure(false);
  const [popoverOpened, setPopoverOpened] = useState(false);

  // Load dữ liệu từ API khi component mount
  useEffect(() => {
    // Luôn load từ API để đảm bảo dữ liệu mới nhất
    callApiGetData();
  }, [id]);

  // ✅ Tự động lưu vào store khi form thay đổi
  useEffect(() => {
    const handleFormChange = () => {
      const values = form.values;
      const dataToSave = { ...values };
      // Chuyển boolean thành Y/N khi lưu vào store
      dataToSave.titleGroupStatus = values.titleGroupStatus ? "Y" : "N";
      dataToSave.configProdStatus = values.configProdStatus ? "Y" : "N";
      dataToSave.displayInTechStatus = values.displayInTechStatus ? "Y" : "N";
      dataToSave.filterProdStatus = values.filterProdStatus ? "Y" : "N";
      dataToSave.shortDescStatus = values.shortDescStatus ? "Y" : "N";
      dataToSave.listTblAttributeValueCommand = vTblAttributeValueCommand;

      store.setAttributeData(dataToSave);
    };

    // Watch for form changes
    const timer = setInterval(() => {
      if (form.isDirty()) {
        handleFormChange();
      }
    }, 500);

    return () => clearInterval(timer);
  }, [form, store, vTblAttributeValueCommand]);

  // ✅ Tự động lưu khi attribute values thay đổi
  useEffect(() => {
    const currentData = store.getAttributeData();
    if (currentData && currentData.id === id) {
      const updatedData = { ...currentData };
      updatedData.listTblAttributeValueCommand = vTblAttributeValueCommand;
      store.setAttributeData(updatedData);
    }
  }, [vTblAttributeValueCommand, store, id]);

  const callApiGetData = async () => {
    open();
    let urlEdit = API_ROUTE.MODIFY_ATTRIBUTE + `?id=${id}`;
    let callapi = await repository.get<MessageResponse<TblAttributeCommand>>(
      urlEdit
    );
    if (!isNullOrUndefined(callapi) && !isNullOrUndefined(callapi?.data)) {
      const dataApi = callapi?.data;
      if (dataApi != null && !isNullOrUndefined(dataApi)) {
        // Chuyển Y/N thành boolean cho form
        const formData = { ...dataApi };
        formData.titleGroupStatus =
          dataApi.titleGroupStatus === "Y" || dataApi.titleGroupStatus === true;
        formData.configProdStatus =
          dataApi.configProdStatus === "Y" || dataApi.configProdStatus === true;
        formData.displayInTechStatus =
          dataApi.displayInTechStatus === "Y" ||
          dataApi.displayInTechStatus === true;
        formData.filterProdStatus =
          dataApi.filterProdStatus === "Y" || dataApi.filterProdStatus === true;
        formData.shortDescStatus =
          dataApi.shortDescStatus === "Y" || dataApi.shortDescStatus === true;

        form.setValues(formData);
        form.resetDirty(formData);

        // Lưu vào store với format Y/N
        const storeData = { ...dataApi };
        storeData.titleGroupStatus =
          dataApi.titleGroupStatus === "Y" || dataApi.titleGroupStatus === true
            ? "Y"
            : "N";
        storeData.configProdStatus =
          dataApi.configProdStatus === "Y" || dataApi.configProdStatus === true
            ? "Y"
            : "N";
        storeData.displayInTechStatus =
          dataApi.displayInTechStatus === "Y" ||
          dataApi.displayInTechStatus === true
            ? "Y"
            : "N";
        storeData.filterProdStatus =
          dataApi.filterProdStatus === "Y" || dataApi.filterProdStatus === true
            ? "Y"
            : "N";
        storeData.shortDescStatus =
          dataApi.shortDescStatus === "Y" || dataApi.shortDescStatus === true
            ? "Y"
            : "N";

        store.setAttributeData(storeData);

        // Load attribute values if available
        if (dataApi.listTblAttributeValueCommand) {
          setTblAttributeValueCommand(dataApi.listTblAttributeValueCommand);
        }

        // Load categories nếu có
        console.log("API Response data:", dataApi);
        console.log(
          "Categories from API:",
          dataApi.listTblCategoryAttributeModels
        );
        if (dataApi.listTblCategoryAttributeModels) {
          store.setSelectedCategories(dataApi.listTblCategoryAttributeModels);
        }
      }
      close();
    } else {
      NotificationExtension.Fails("Dữ liệu không tồn tại");
      modals.closeAll();
    }
  };
  const fields = vTblAttributeValueCommand?.map((_, index) => (
    <FormValueAdd
      idAttr={form.values.id}
      data={_}
      index={index}
      list={vTblAttributeValueCommand}
      set={setTblAttributeValueCommand}
    />
  ));
  return (
    <>
      <Divider my="sm" />
      <Box className="flex-none" component="form" miw={600} mx="auto">
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />
        <TextInput
          label="Tên thuộc tính: "
          placeholder="Nhập tên thuộc tính..."
          withAsterisk
          {...form.getInputProps("attributeName")}
        />
        <TextInput
          mt={"lg"}
          label="Mã thuộc tính: "
          placeholder="Nhập mã thuộc tính..."
          withAsterisk
          {...form.getInputProps("attributeCode")}
        />
        <Textarea
          label="Mô tả tóm tắt (nếu muốn hiển thị và giải thích ý nghĩa cho khách hàng)"
          placeholder="Nhập mô tả..."
          mt="lg"
          autosize
          minRows={3}
          {...form.getInputProps("description")}
        />
        <Text fw={500} fs={"13px"}>
          Lựa chọn áp dụng
        </Text>
        <Checkbox
          mt={"xs"}
          label="Dùng là tiêu đề nhóm cho các thuộc tính đứng sau"
          checked={Boolean(form.values.titleGroupStatus)}
          onChange={(event) =>
            form.setFieldValue("titleGroupStatus", event.currentTarget.checked)
          }
        />
        <Divider my="xs" variant="dotted" />
        <Checkbox
          label="Dùng lọc Sản phẩm ở danh mục"
          checked={Boolean(form.values.filterProdStatus)}
          onChange={(event) =>
            form.setFieldValue("filterProdStatus", event.currentTarget.checked)
          }
        />
        <Divider my="sm" variant="dotted" />
        <Checkbox
          label="Hiển thị ở thông tin tóm tắt Sản phẩm"
          checked={Boolean(form.values.shortDescStatus)}
          onChange={(event) =>
            form.setFieldValue("shortDescStatus", event.currentTarget.checked)
          }
        />
        <Divider my="sm" variant="dotted" />
        <Checkbox
          label="Hiển thị ở bảng thông số kỹ thuật"
          checked={Boolean(form.values.displayInTechStatus)}
          onChange={(event) =>
            form.setFieldValue(
              "displayInTechStatus",
              event.currentTarget.checked
            )
          }
        />
        <Divider my="sm" variant="dotted" />
        <Checkbox
          label="Dùng để tạo các cấu hình của Sản phẩm"
          checked={Boolean(form.values.configProdStatus)}
          onChange={(event) =>
            form.setFieldValue("configProdStatus", event.currentTarget.checked)
          }
        />
        <TextInput
          mt={"lg"}
          label="Mã bộ lọc trên Url (v.d. cpu (trên link lọc ?cpu=32Ghz&ram=32GB)): "
          placeholder="Nhập mã bộ lọc..."
          {...form.getInputProps("filterCode")}
        />
        <Radio.Group
          name="favoriteFramework"
          label="Phân loại"
          withAsterisk
          {...form.getInputProps("attributeGroup")}
        >
          <Group mt="xs">
            <Stack>
              <Radio
                value="L"
                label="Local - Chỉ áp dụng cho một số loại Sản phẩm"
              />
              <Radio
                value="G"
                label="Global - Áp dụng cho tất cả Sản phẩm (v.d: Xuất xứ, Màu sắc, Bảo hành)"
              />
            </Stack>
          </Group>
        </Radio.Group>
        <TextInput
          mt={"lg"}
          type="number"
          label="Thứ tự xuất hiện (cao xếp trước): "
          placeholder="Nhập thứ tự..."
          min={0}
          max={32000}
          {...form.getInputProps("orderNumber")}
        />
        <Text mt={"xl"} fw={500} fs={"11px"}>
          Quản lý các giá trị
        </Text>
        {fields}
        <Group justify="center" mt="md">
          <Button
            onClick={() => {
              let check = vTblAttributeValueCommand.filter(
                (x) =>
                  x.value === undefined ||
                  x.value === null ||
                  x.value.length < 1
              );
              if (check && check.length > 0) {
                NotificationExtension.Info("Có giá trị chưa được nhập !");
                return;
              }
              setTblAttributeValueCommand((prevValues: any) => [
                ...prevValues,
                entityValue,
              ]);
            }}
          >
            Thêm giá trị
          </Button>
        </Group>
        <Divider my="sm" />
        <Group
          justify="center"
          mt="xs"
          p="5px 0"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Button
            type="button"
            color="green"
            onClick={onSaveFinal}
            leftSection={<IconCheck size={18} />}
          >
            Lưu
          </Button>
          <ButtonClose />
        </Group>
      </Box>
    </>
  );
};

export default EditViewNew;
